<div cdkDropList *ngIf="formGroups && formVariant" (cdkDropListDropped)="reorder($event)">
  <div cdkDrag *ngFor="let formGroupStep of formGroups; let index = index" [formGroup]="formGroupStep">
    <div class="space-h-m background-grey area mat-elevation-z4">
      <div cdkDragHandle class="column-drag"></div>
      <div class="step-detail">
        <div class="step-line">
          <div class="column-description">
            <mat-form-field appearance="fill">
              <mat-label> {{ 'STEP' | translate }} {{ index + 1 }} </mat-label>
              <textarea
                id="RecipesModifyStepsStepDescTxt"
                formControlName="applicationDescription"
                rows="{{ domain === 'PRO_COO' ? '3' : '8' }}"
                (keydown.enter)="$event.preventDefault()"
                #stepLineNameField
                (paste)="fastInput($event, index)"
                matInput
              >
              </textarea>
            </mat-form-field>

            <mat-error *ngIf="this.warningsApplianceDescription[index] === true">
              {{ 'VARIANTS.STEPS.SHORT_TEXT_TOO_LONG' | translate }}
            </mat-error>
            <mat-form-field appearance="fill" *ngIf="domain === 'PRO_COO'">
              <mat-label> {{ 'VARIANTS.STEPS.SHORT_TEXT' | translate }} </mat-label>
              <textarea
                formControlName="applianceDescription"
                rows="3"
                (ngModelChange)="checkDescriptionSize(formGroupStep, index)"
                (keydown.enter)="$event.preventDefault()"
                (paste)="fastInput($event, index)"
                matInput
              >
              </textarea>
            </mat-form-field>
          </div>
          <div class="column-picture">
            <app-media-selector-inputs
              [imgPlaceHolderHeight]="160"
              [imgPlaceHolderWidth]="160"
              [formArray]="formArray"
              [formVariant]="formVariant"
              [formArrayIndex]="index"
              [variant]="variant"
            ></app-media-selector-inputs>
          </div>
        </div>

        <div class="step-line space-h-m">
          <mat-form-field class="column-select form-field-no-header">
            <mat-label> {{ 'TYPE' | translate }} </mat-label>
            <mat-select id="RecipesModifyStepsStepTypeBtn{{ index }}" formControlName="type" required>
              <div id="RecipesModifyStepsStepTypeLst{{ index }}">
                <mat-option *ngFor="let type of stepTypesDataref" [value]="type.key">
                  {{ type.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="column-select form-field-no-header">
            <mat-label> {{ 'KITCHENWARE' | translate }} </mat-label>
            <mat-select id="RecipesModifyStepsStepAccessoryBtn{{ index }}" formControlName="kitchenwares" multiple>
              <div id="RecipesModifyStepsStepAccessoryLst{{ index }}">
                <mat-option *ngFor="let kitchenware of kitchenwares" [value]="kitchenware">
                  {{ getName(kitchenware, kitchenwaresDataref) }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="column-select form-field-no-header">
            <mat-label> {{ 'USTENSILS' | translate }} </mat-label>
            <mat-select
              id="RecipesModifyStepsStepUstensilBtn{{ index }}"
              formControlName="utensils"
              multiple
              (selectionChange)="updateUtensil()"
            >
              <div id="RecipesModifyStepsStepUstensilLst{{ index }}">
                <mat-option *ngFor="let utensil of utensilDataref" [value]="utensil.key">
                  {{ utensil.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="step-line space-h-m">
          <mat-form-field class="column-select form-field-no-header">
            <mat-label> {{ 'RECIPES_EDIT.INGREDIENTS.INGREDIENTS' | translate }} </mat-label>
            <mat-select formControlName="ingredients" id="RecipesModifyStepsStepIngredientBtn-{{ index }}" multiple>
              <div id="RecipesModifyStepsStepIngredientLst{{ index }}">
                <mat-option *ngFor="let ingredient of ingredients" [value]="ingredient.identifier">
                  {{ ingredient.applicationDescription }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="column-select form-field-no-header">
            <mat-label> {{ 'MENU.REFERENCES.TECHNIQUES.TITLE' | translate }} </mat-label>
            <mat-select id="RecipesModifyStepsStepTechnicBtn" formControlName="techniques" multiple (selectionChange)="updateTechnique()">
              <div id="RecipesModifyStepsStepTechnicLst{{ index }}">
                <mat-option *ngFor="let technique of techniqueDataref" [value]="technique.key">
                  {{ technique.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="column-select form-field-no-header">
            <mat-label> {{ 'MENU.SLIDESHOWS.TITLE' | translate }} </mat-label>
            <mat-select id="RecipesModifyStepsStepTipBtn" formControlName="slideshow" [disabled]="slideshows?.length === 0">
              <mat-option *ngIf="(slideshows?.length || 0) > 0"> </mat-option>
              <mat-option *ngFor="let slideshow of slideshows" [value]="slideshow.key">
                {{ slideshow.translatedName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-accordion>
            <mat-expansion-panel
              #programmesPanel
              class="programmes"
              (opened)="panelProgrammesState = true"
              (closed)="panelProgrammesState = false"
            >
              <mat-expansion-panel-header class="panel-header">
                <mat-panel-title>
                  <h4 id="RecipesModifyStepsStepProgramBtn" class="programmes-title space-t-s">
                    {{ 'PROGRAM' | translate | uppercase }}
                  </h4>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <app-programme-inputs
                  id="RecipesModifyStepsStepProgramLst"
                  [formVariant]="formVariant"
                  [formGroupStep]="formGroupStep"
                  [programList]="programList"
                  [applianceGroupsList]="applianceGroupsList"
                  [parameterSettingsList]="parameterSettingsList"
                  [psNamesList]="psNamesList"
                  [variant]="variant"
                ></app-programme-inputs>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
      <div class="column-actions">
        <i class="fas fa-trash space-l-l" aria-hidden="true" (click)="delete(index)"></i>
      </div>
    </div>
  </div>
</div>
<div class="footer background-grey mat-elevation-z4">
  <button id="RecipesModifyStepsBtn" mat-button class="btn" (click)="newLine()">
    {{ 'CREATE_STEPS' | translate | uppercase }}
    <i class="fas fa-plus space-l-m space-v-s" aria-hidden="true"></i>
  </button>
</div>
